module.exports = "https://static.wmbcdn.com/uniweb/images/895768d59a70c4e5fd8f8dbb1880fdd1.jpg";